import { useIsFetching } from "@tanstack/react-query";

export function GlobalFetchingIndicator() {
  const activeQueries = useIsFetching();

  if (activeQueries === 0) {
    return null;
  }

  return (
    <div
      role="status"
      aria-label="Refreshing MinistryIQ data"
      className="fixed inset-x-0 top-0 z-[100] h-1 overflow-hidden bg-indigo-950/40"
    >
      <div className="h-full w-1/3 animate-pulse bg-indigo-500" />
    </div>
  );
}
